import OkC from "shared/util/OkcApi";

window.Log = (text) => {
	OkC.post("/log/warn", {
		data: {
			text,
		},
	});
};



// WEBPACK FOOTER //
// ./src/legacy/log.js